import React, { createContext, useContext, useState, useEffect } from 'react';
import { MODULES, getModule } from '../modules/registry';

const ModuleContext = createContext(null);

export const ModuleProvider = ({ children }) => {
  const [activeModule, setActiveModule] = useState(() => {
    const saved = localStorage.getItem('zz_module');
    return getModule(saved || 'agri');
  });

  useEffect(() => {
    // Apply theme to body
    document.body.setAttribute('data-module', activeModule.bodyAttr);
    localStorage.setItem('zz_module', activeModule.id);

    // Inject CSS vars dynamically for this module
    const root = document.documentElement;
    root.style.setProperty('--primary',       activeModule.color);
    root.style.setProperty('--primary-hover', activeModule.colorHover);
    root.style.setProperty('--primary-light', activeModule.colorLight);
    root.style.setProperty('--primary-mid',   activeModule.colorMid);
    root.style.setProperty('--primary-rgb',   hexToRgb(activeModule.color));
  }, [activeModule]);

  const switchModule = (id) => {
    const mod = getModule(id);
    if (!mod.enabled) return; // don't switch to disabled modules
    setActiveModule(mod);
  };

  return (
    <ModuleContext.Provider value={{ activeModule, switchModule, allModules: MODULES }}>
      {children}
    </ModuleContext.Provider>
  );
};

export const useModule = () => useContext(ModuleContext);

function hexToRgb(hex) {
  const r = parseInt(hex.slice(1,3), 16);
  const g = parseInt(hex.slice(3,5), 16);
  const b = parseInt(hex.slice(5,7), 16);
  return `${r},${g},${b}`;
}
